import { put, call } from "redux-saga/effects";
import log from "loglevel";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getAccountSaga(action: types.GetAccountActionType) {
  try {
    const response = yield call(services.getAccountService, action.payload);
    yield put({ type: actions.GET_ACCOUNT_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ACCOUNT_ERROR, response: error });
    toastr.error("Account Not Loaded", `${error.error.message}`);
  }
}

export function* getAccountsSaga(action: types.GetAccountsActionType) {
  try {
    const response = yield call(services.getAccountsService);
    yield put({ type: actions.GET_ACCOUNTS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ACCOUNTS_ERROR, response: error });
    toastr.error("Accounts Not Loaded", `${error.error.message}`);
  }
}

export function* getCurrentUserAccountOwnerSaga(
  action: types.GetCurrentUserAccountOwnerActionType
) {
  try {
    const response = yield call(
      services.getCurrentUserAccountOwnerByAccountNameService,
      action.payload
    );
    yield put({
      type: actions.GET_CURRENT_USER_ACCOUNT_OWNER_SUCCESS,
      response,
    });
  } catch (error) {
    yield put({
      type: actions.GET_CURRENT_USER_ACCOUNT_OWNER_ERROR,
      response: error,
    });
  }
}

export function* addAccountSaga(action: types.AddAccountActionType) {
  try {
    const addResponse = yield call(services.addAccountService, action.payload);
    const getResponse = yield call(services.getAccountsService);
    if (addResponse.data) {
      yield put({ type: actions.ADD_ACCOUNT_SUCCESS, response: addResponse });
      yield put({ type: actions.GET_ACCOUNTS_SUCCESS, response: getResponse });
      toastr.success("Account Created", `Added '${action.payload.body.name}'`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_ACCOUNT_ERROR, response: error });
    toastr.error("Account Not Created", `${error.error.message}`);
  }
}

export function* modifyAccountSaga(action: types.ModifyAccountActionType) {
  try {
    const modifyResponse = yield call(
      services.modifyAccountService,
      action.payload
    );
    const getResponse = yield call(services.getAccountsService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_ACCOUNT_SUCCESS,
        response: modifyResponse,
      });
      yield put({ type: actions.GET_ACCOUNTS_SUCCESS, response: getResponse });
      toastr.success(
        "Account Modified",
        `Modified '${action.payload.body.name}'`
      );
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({ type: actions.MODIFY_ACCOUNT_ERROR, response: error });
    toastr.error("Account Not Modified", `${error.error.message}`);
  }
}

export function* deleteAccountSaga(action: types.DeleteAccountActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteAccountService,
      action.payload
    );
    const getResponse = yield call(services.getAccountsService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_ACCOUNT_SUCCESS,
        response: deleteResponse,
      });
      yield put({ type: actions.GET_ACCOUNTS_SUCCESS, response: getResponse });
      toastr.success("Account Deleted", "All dependencies deleted");
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_ACCOUNT_ERROR, response: error });
    toastr.error("Account Not Deleted", `${error.error.message}`);
  }
}
